import React from 'react';
import { Link } from 'react-router-dom';
import { KiteIcon } from '@kite/react-kite';
import { SortableTable } from '@kite/react-kite-plus';

import ServiceIcon from '../ServiceIcon/ServiceIcon';
import TableStatus from '../TableStatus/TableStatus';

import { IEpisode } from '../../utils/models';
import { renderTableDate } from '../../utils/helpers';

import './AllEpisodesTable.scss';

export interface IAllEpisodesTableProps {
  episodeData: IEpisode[];
  onSortClick: (sortHeader: string) => void;
  ascending: boolean;
  sortHeader: string;
  loading: boolean;
}

const AllEpisodesTable = ({
  episodeData,
  onSortClick,
  sortHeader,
  ascending,
  loading,
}: IAllEpisodesTableProps) => {
  const renderServiceIcons = (services) => {
    return services.map(({ type, status, language }) => (
      <ServiceIcon type={type} status={status} language={language} />
    ));
  };

  const columns = [
    {
      label: 'Title',
      sortKey: 'title',
      size: 1.5,
    },
    {
      label: 'Series',
      sortKey: 'seriesTitle',
      sortEnabled: false,
    },
    {
      label: 'S#',
      sortKey: 'season',
      size: 0.2,
      sortEnabled: false,
    },
    {
      label: 'E#',
      sortKey: 'number',
      size: 0.2,
      sortEnabled: false,
    },
    {
      label: 'Added',
      sortKey: 'addedOn',
      size: 0.4,
      render: ({ addedOn }) => renderTableDate(addedOn),
    },
    {
      label: 'Updated',
      sortKey: 'updatedOn',
      size: 0.4,
      render: ({ updatedOn }) => renderTableDate(updatedOn),
    },
    {
      label: 'Feature Status',
      sortKey: 'status',
      render: ({ status, errors }) => (
        <TableStatus status={status} errors={errors} />
      ),
    },
    {
      label: 'Services',
      sortKey: 'services',
      sortEnabled: false,
      size: 0.4,
      render: (item) => renderServiceIcons(item.services),
    },
    {
      label: '',
      sortKey: '',
      sortEnabled: false,
      render: (item) => (
        <Link
          to={`/series/${item.seriesId}/episodes/${item.id}`}
          className="movies-table__link"
        >
          View Episode
          <KiteIcon name="chevron-right" color="#0073d1" />
        </Link>
      ),
      size: 0.6,
    },
  ];

  return (
    <SortableTable
      className="all-episodes-table"
      columns={columns}
      tableData={episodeData}
      initialSortHeader="title"
      onSortClick={onSortClick}
      sortHeader={sortHeader}
      reverseSort={!ascending}
      loading={loading}
      generateRowLink={(item: any) =>
        `/series/${item.seriesId}/episodes/${item.id}`
      }
    />
  );
};

export default AllEpisodesTable;
